import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/style.css';
import './styles/floating-label.css';
import './styles/fonts.css';

ReactDOM.render(<App />, document.getElementById('App'));
